/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgScatterPlotBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 12.25C9.57107 12.25 11.25 13.9289 11.25 16C11.25 18.0711 9.57107 19.75 7.5 19.75C5.42893 19.75 3.75 18.0711 3.75 16C3.75 13.9289 5.42893 12.25 7.5 12.25ZM17.5 13.75C18.7426 13.75 19.75 14.7574 19.75 16C19.75 17.2426 18.7426 18.25 17.5 18.25C16.2574 18.25 15.25 17.2426 15.25 16C15.25 14.7574 16.2574 13.75 17.5 13.75ZM13.5 3.75C15.2949 3.75 16.75 5.20507 16.75 7C16.75 8.79493 15.2949 10.25 13.5 10.25C11.7051 10.25 10.25 8.79493 10.25 7C10.25 5.20507 11.7051 3.75 13.5 3.75Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);
const SvgScatterPlot = wrapIcon(SvgScatterPlotBase);
export default SvgScatterPlot;
